import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

export const ConnectedAppsSectionStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "connected-apps-section",
})`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .sectionDescription {
    font-size: 13px;
    color: ${greyMui._700};
    margin: 0;
  }

  .connectAgentLink {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 10px;
    min-height: 44px;
    padding: 8px 16px;
    border: 1px solid ${greyMui._300};
    border-radius: 999px;
    background: ${greyMui._50};
    color: ${greyMui._900};
    text-decoration: none;

    &:hover {
      border-color: ${deepPurpleMui._900};
    }

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui._900};
      outline-offset: 2px;
    }
  }

  .connectAgentIcon {
    color: ${deepPurpleMui._900};
  }

  .connectAgentText {
    display: flex;
    flex-direction: column;
  }

  .connectAgentTitle {
    font-size: 14px;
    font-weight: 600;
  }

  .connectAgentHint {
    font-size: 12px;
    color: ${greyMui._700};
  }

  .connectAgentExternalIcon {
    font-size: 16px;
    color: ${greyMui._700};
  }

  .visuallyHidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }

  .emptyState {
    font-size: 14px;
    color: ${greyMui._600};
  }

  .grantRow {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid ${greyMui._300};
    border-radius: 8px;
  }

  .grantLogo {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    object-fit: contain;
  }

  .grantInfo {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex-grow: 1;

    .grantName {
      font-size: 14px;
      font-weight: 600;
    }

    .grantMeta {
      font-size: 12px;
      color: ${greyMui._700};
    }
  }
`;
